module.exports = __webpack_public_path__ + "img/2023.9baa2b77.jpg";